import React from 'react';
import { ArrowUpRightIcon, PaletteIcon } from 'lucide-react';
import { STYLE_CONCEPTS } from '../lib/constants';
import { Reveal } from './Reveal';
const accentStyles = {
  coral: 'bg-coral text-white',
  lime: 'bg-lime text-ink',
  cobalt: 'bg-brand-500 text-white'
};
export function StyleShowcase() {
  return <section id="estilos" className="w-full bg-ink py-20 text-white sm:py-28" data-id="element-133" data-mp="jgaf7cgird93">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-134" data-mp="eis3xff14lxx">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end" data-id="element-135" data-mp="eg5tn80r7sc0">
          <div className="max-w-2xl" data-id="element-136" data-mp="9huk6yedfjub">
            <Reveal data-id="element-137" data-mp="5hantx1mgk98">
              <span className="inline-flex items-center gap-2 bg-coral px-3 py-2 text-[0.7rem] font-extrabold uppercase tracking-[0.13em] text-white" data-id="element-138" data-mp="5gslciod99sv">
                <PaletteIcon className="h-4 w-4" data-id="element-139" data-mp="kk6l6e2zim8" />
                No hago webs iguales
              </span>
            </Reveal>
            <Reveal delay={0.05} data-id="element-140" data-mp="1uws0qhikvvgy">
              <h2 className="mt-6 font-display text-5xl font-extrabold leading-[0.93] sm:text-6xl" data-id="element-141" data-mp="1uxtnhj8yi6ei">
                Tu web puede verse tan viva como tu idea.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1} data-id="element-142" data-mp="1n44ncx0d1psx">
            <p className="max-w-md text-base leading-relaxed text-slate-300" data-id="element-143" data-mp="1n0750dllx2a3">
              Estas son direcciones visuales: el punto de partida para crear una presencia que tenga
              tu propia energía.
            </p>
          </Reveal>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-12 lg:items-start" data-id="element-144" data-mp="21rzhmhu0o284">
          {STYLE_CONCEPTS.map((concept, index) => <Reveal key={concept.category} delay={index * 0.08} className={index === 0 ? 'lg:col-span-7' : index === 1 ? 'lg:col-span-5 lg:mt-16' : 'lg:col-span-7'} data-id="element-145" data-mp="25uvt7ol52y2k" data-mpi={index}>
              <article className="overflow-hidden border border-white/15 bg-white text-ink" data-id="element-146" data-mp="2kqljw019rzdm">
                <div className="relative overflow-hidden" data-id="element-147" data-mp="2ph1znqskbx35">
                  <img src={concept.imageUrl} alt={concept.alt} loading="lazy" className={`w-full object-cover ${index === 1 ? 'aspect-[4/4.4]' : 'aspect-[4/3]'}`} data-id="element-148" data-mp="2pilgbii4sa5g" />
                  <span className={`absolute left-4 top-4 px-3 py-2 text-xs font-extrabold uppercase tracking-[0.1em] ${accentStyles[concept.accent]}`} data-id="element-149" data-mp="2pe1p17wquvx4">
                    Concepto
                  </span>
                </div>
                <div className="flex flex-col gap-5 p-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-150" data-mp="2gfprelxgmxv6">
                  <div data-id="element-151" data-mp="2blvd5y0mjb3h">
                    <p className="text-xs font-extrabold uppercase tracking-[0.12em] text-brand-600" data-id="element-152" data-mp="2bllj9zcgkjsi">{concept.category}</p>
                    <h3 className="mt-2 font-display text-3xl font-extrabold leading-none" data-id="element-153" data-mp="21piioxx98t7o">{concept.label}</h3>
                    <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-600" data-id="element-154" data-mp="1wqp5z7psl68k">{concept.description}</p>
                  </div>
                  <ArrowUpRightIcon className="h-6 w-6 shrink-0 text-coral" data-id="element-155" data-mp="1sp3u9pozuxzy" />
                </div>
              </article>
            </Reveal>)}

          <Reveal delay={0.18} className="lg:col-span-5 lg:mt-0" data-id="element-156" data-mp="c7llwus0rkwn">
            <div className="flex min-h-[19rem] flex-col justify-between bg-lime p-7 text-ink sm:p-9" data-id="element-157" data-mp="c9zft0ayqr2m">
              <p className="font-display text-4xl font-extrabold leading-[0.94]" data-id="element-158" data-mp="h5esvq15cixz">
                No necesitas encajar en una plantilla.
              </p>
              <p className="max-w-xs text-sm font-bold leading-relaxed" data-id="element-159" data-mp="3kp9dlw7tla4l">
                Necesitas una web que ordene tu propuesta y haga que den ganas de saber más de ti.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}